import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable()
export class ListingForwarderGuard implements CanActivate {
  private static lastRoute: ActivatedRouteSnapshot | undefined;
  constructor(private router: Router) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    // Infinite Loop Prevention.
    if (ListingForwarderGuard.lastRoute?.params) {
      if (
        Object.entries(ListingForwarderGuard.lastRoute?.params).join('/') === Object.entries(route?.params).join('/')
      ) {
        return false;
      } else {
        ListingForwarderGuard.lastRoute = route;
      }
    } else {
      ListingForwarderGuard.lastRoute = route;
    }

    // Route Fixes
    if (route.params['location'] && route.params['location'].includes('_')) {
      const location = route.params['location'].replace('_', '-');
      let newRoute = `/rv-camping/${location}/${route.params['listingId']}`;
      if (route.params['name']) {
        newRoute = `/rv-camping/${location}/${route.params['name']}/${route.params['listingId']}`;
      }
      await this.router.navigateByUrl(newRoute);
      return true;
    } else if (route.params['name'] && route.params['listingId'] && /^\d+$/.test(route.params['name'])) {
      // listing ID and Name are swapped.
      const name = route.params['listingId'].replace('_', '-');
      const listingId = route.params['name'];
      await this.router.navigateByUrl(`/rv-camping/${name}/${listingId}`);
    } else {
      if (route.data.deprecated) {
        let params = '';
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        for (const [key, value] of Object.entries(route.params)) {
          params += '/' + value;
        }
        await this.router.navigateByUrl(`/rv-camping${params}`);
        return false;
      }
      return true;
    }
    return false;
  }
}
